import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusLayout from "./StatusLayout";
import { useCase } from "../../context/CaseContext";
import { downloadGenericResult } from "../../lib/everifyStatusApi";
import { toast } from "react-toastify";

const ManualReviewPage = () => {
  const { activeCaseNumber } = useCase();
  const navigate = useNavigate();
  const [downloadLoading, setDownloadLoading] = useState(false);

  const handleDownload = async () => {
    if (!activeCaseNumber) {
      toast.error("No active case available.");
      return;
    }
    try {
      setDownloadLoading(true);
      await downloadGenericResult(activeCaseNumber, `manual-review-${activeCaseNumber}.pdf`);
    } catch (error) {
      toast.error("Unable to download the result.");
    } finally {
      setDownloadLoading(false);
    }
  };

  const footerActions = [
    
  ];

  return (
    <StatusLayout
      title="Case under Manual Review"
      description="The case is under manual review. No action is needed at this time."
      footerActions={footerActions}
    >
      <div className="status-section">
        <h3>Next Steps</h3>
        <p>No Actions Required</p>
        <p>You can find the updated status in the E-Verify Home Page.</p>
      </div>
    </StatusLayout>
  );
};

export default ManualReviewPage;
